module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u-Home-Banner-01-2564a853a1762db4f19712a65cd17452.jpg";